<template>
  <div class="only-list" :class="[defaultBool?'no-list-data':'']">
    <div  @mouseleave="leaveFun(className)">
      <div class="loading" >
        <share class="only-list-share" :share="item.share" :good="item.good"></share>
        <a class="loading-div" :href="item.panoUrl||'javascript:void(0);'" :target="item.panoUrl?'_blank':''">
          <i class="icon-img icon-href"></i>
          <template v-if="lazy.bool">
            <div :class="[lazy.elementClass]" :data-background="item.imgSrc||defaultImg"></div>
          </template>
          <template v-else>
            <div :style="backgroundImage"></div>
          </template>
        </a>
        <img :src="seating" alt="">
        <div class="only-list-code only-list-code-hide">
          <div class="code-content"><div :id="className" style="width: 100%;height: 100%"></div></div>
        </div>
      </div>
      <div class="posRe">
        <div class="name">
          <div>
            <h3 class="oneRow" v-html="item.name||'暂无'"></h3>
            <template v-if="isPc==1">
              <span class="icon-img icon-qr" ref="iconQr" @click="searchClick(className)"></span>
            </template>
            <template v-else>
              <span class="icon-img icon-qr" @mouseenter="searchEnter(className)"></span>
            </template>
          </div>
        </div>
        <div class="list-info list-info1 posRe" :class="[item.address?'':'opacity3']">
          <span class="icon-img icon-address"></span>
          <p class="oneRow" :title="item.address">{{item.address || '暂无'}}</p>
        </div>
        <div class="list-info" :class="[item.phone?'':'opacity3']">
          <span class="icon-img icon-phone"></span>
          <p class="oneRow list-info-phone">{{item.phone || '暂无'}}</p>
        </div>
        <div class="btn">
          <!--<button>进入地图</button>-->
          <a :href="item.panoUrl" target="_pan"><span>进入全景</span></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import share from '@/components/share'
export default {
  props: ['item', 'lazy', 'className','defaultBool'],
  name: 'onlyList',
  data () {
    return {
      backgroundImage: {
        backgroundImage: ''
      },
      seating: './static/images/icon/loading.png',
      qrBool: true,
      isPc: true,
      qrClickBool: true,
      defaultImg:'./static/images/default423.jpg'
    }
  },
  components: {
    share: share
  },
  created () {
    this.isPc = localStorage.getItem('isMobile')
  },
  mounted () {
    let that = this
    that.backgroundImage.backgroundImage = 'url(' +(that.item.imgSrc || that.defaultImg) + ')'
  },
  methods: {
    leaveFun: function (className) {
      this.qrBool = true
      this.publicJs.qrCode(className, false)
    },
    searchEnter: function (className) {
      this.qrBool = false
      this.publicJs.qrCode(className, true)
    },
    searchClick: function (className) {
      let that = this
      that.$nextTick(function () {
        let iconQrObj = $(that.$refs.iconQr)
        if (iconQrObj.hasClass('yes-qr')) {
          that.qrBool = true
          that.publicJs.qrCode(className, false)
          iconQrObj.removeClass('yes-qr')
        } else {
          $('.icon-qr').removeClass('yes-qr')
          that.qrBool = false
          that.publicJs.qrCode(className, true)
          iconQrObj.addClass('yes-qr')
        }
      })
    }
  },
  watch: {
    item: function (a, b) {
      if (a) {
        let that = this;
        that.backgroundImage.backgroundImage = 'url(' +(that.item.imgSrc || that.defaultImg) + ')'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .only-list{
    padding: 8px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .loading-div,.loading img{
    border-radius: 8px;
  }
  .name{
    padding-right: 30px;
    margin: 13px 0;
  }
  .name>div{
    max-width: 100%;
    display: inline-block;
    position: relative;
  }
  .icon-qr{
    position: absolute;
    top: -1px;
    right: -30px;
    width: 21px;
    height: 21px;
    background-position: -739px -238px;
  }
  .screen3 .name{
    padding-right: 16px;
  }
  .screen3 .icon-qr{
    background-position: -340px -254px;
    width: 14px;
    height: 14px;
    right: -16px;
    top:0;
  }
  h3{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  p{
    /*max-width: 120px;*/
    font-size: 14px;
    font-weight: 500;
    color: #878787;
    padding-right: 120px;
  }
  .list-info{
    position: relative;
    padding: 2px 0 2px 27px;
    height: 18px;
  }
  .list-info1{
    margin-bottom:5px;
  }
  .list-info1 p{
    padding-right: 0;
  }
  .list-info .icon-img{
    position: absolute;
    left: 0;
    top:0;
  }
  .list-info .icon-phone{
    top:0;
  }
  .btn{
    position: absolute;
    right: 0;
    bottom:-5px;
  }
  .btn a{
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    color: #248DDF;
    background-color: inherit;
    width: 80px;
    height: 30px;
    border: 1px solid #248DDF;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    line-height: 30px;
    position: relative;
    overflow: hidden;
  }
  .btn span{
    position: relative;
    z-index: 2;
  }
  .icon-href{
    position: absolute;
    width: 82px;
    height: 68px;
    top: 50%;
    z-index: 7;
    left: 50%;
    margin-left: -41px;
    margin-top: -34px;
    background-position: -420px -390px;
    display: none;
  }

  .only-list:hover .icon-href{
    display: block;
    -webkit-animation: zoomIn 0.5s;
    -o-animation: zoomIn 0.5s;
    animation: zoomIn 0.5s;
  }
  .only-list:hover .icon-href::after{
    -webkit-animation: zoomIn 1.2s 10;
    -o-animation: zoomIn 1.2s 10;
    animation: zoomIn 1.2s 10;
  }
  .screen3 .only-list:hover .icon-href::after{
    display: none;
  }
  @keyframes featuresicon {
    50% {
      transform: rotateY(0);
    }
    100% {
      transform: rotateY(-180deg);
    }
  }
  @-webkit-keyframes featuresicon {
    50% {
      transform: rotateY(0);
    }
    100% {
      transform: rotateY(-180deg);
    }
  }

  .only-list-share{
    position: absolute;
    right:17px;
    top:16px;
    z-index: 4;
    color: white;
  }
  .only-list>div{
    position: relative;
    border-radius: 10px;
    padding: 1rem;
    line-height: 1;
    background-color: white;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all 0.6s ease-in-out;
    -moz-transition: all 0.6s ease-in-out;
    -ms-transition: all 0.6s ease-in-out;
    -o-transition: all 0.6s ease-in-out;
    transition: all 0.6s ease-in-out;
  }
  .only-list:hover>div{
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
    -webkit-box-shadow:0px 0px 12px 3px rgba(0, 0, 0, 0.14);
    -moz-box-shadow:0px 0px 12px 3px rgba(0, 0, 0, 0.14);
    box-shadow:0px 0px 12px 3px rgba(0, 0, 0, 0.14);
    -webkit-animation: onlyListAnimation 0.6s;
    -o-animation: onlyListAnimation 0.6s;
    animation: onlyListAnimation 0.6s;
  }
  .only-list:hover .icon-qr{
    background-position: -697px -238px;
  }
  @keyframes onlyListAnimation {
    0%{
      -webkit-transform: translateY(0);
      -moz-transform: translateY(0);
      -ms-transform: translateY(0);
      -o-transform: translateY(0);
      transform: translateY(0);
    }
    100%{
      -webkit-transform: translateY(-4px);
      -moz-transform: translateY(-4px);
      -ms-transform: translateY(-4px);
      -o-transform: translateY(-4px);
      transform: translateY(-4px);
    }
  }
  .only-list:hover h3{
    color: #248DDF;
  }
  .only-list:hover .btn a{
    color: #fff;
    border-color: inherit;
  }
  .only-list .loading-div>div{
    -webkit-transition: all 0.8s;
    -moz-transition: all 0.8s;
    -ms-transition: all 0.8s;
    -o-transition: all 0.8s;
    transition: all 0.8s;
  }
  .only-list:hover .loading-div>div{
    -webkit-transform: scale(1.2);
    -moz-transform: scale(1.2);
    -ms-transform: scale(1.2);
    -o-transform: scale(1.2);
    transform: scale(1.2);
    -webkit-transition: transform 0.8s ease-in-out;
    -moz-transition: transform 0.8s ease-in-out;
    -ms-transition: transform 0.8s ease-in-out;
    -o-transition: transform 0.8s ease-in-out;
    transition: transform 0.8s ease-in-out;
  }
  .btn a::after{
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    /*z-index: -1;*/
    background: linear-gradient(left, #0687f3, #4caffc);
    background: -ms-linear-gradient(left, #0687f3, #4caffc);
    background: -webkit-linear-gradient(left, #0687f3, #4caffc);
    background: -moz-linear-gradient(left, #0687f3, #4caffc);
    -webkit-transform: scaleY(0);
    -ms-transform: scaleY(0);
    transform: scaleY(0);
    -webkit-transition: -webkit-transform 0.8s cubic-bezier(.165,.84,.44,1) 0s;
    transition: -webkit-transform 0.8s cubic-bezier(.165,.84,.44,1) 0s;
    -o-transition: transform 0.8s cubic-bezier(.165,.84,.44,1) 0s;
    transition: transform 0.8s cubic-bezier(.165,.84,.44,1) 0s;
    transition: transform 0.8s cubic-bezier(.165,.84,.44,1) 0s, -webkit-transform 0.8s cubic-bezier(.165,.84,.44,1) 0s;
    transition: transform 0.8s cubic-bezier(.165,.84,.44,1) 0s,-webkit-transform 0.8s cubic-bezier(.165,.84,.44,1) 0s;
    -webkit-transform-origin: top left;
    -ms-transform-origin: top left;
    transform-origin: top left;
  }
  .only-list:hover .btn a::after{
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: bottom left;
    -ms-transform-origin: bottom left;
    transform-origin: bottom left;
  }
  /*.only-list:hover .icon-address{*/
  .only-list:hover .icon-address{
    background-position:-113px -16px;
  }
  .only-list:hover .icon-phone {
    background-position: -163px -17px;
  }

  .loading{
    /*overflow: hidden;*/
  }

  .screen2 .only-list,.screen3 .only-list{
    padding: 5px;
  }
  .screen2 .only-list>div{
    padding: 0.75rem;
  }

  .screen2 .list-info-phone{
    padding-right: 90px;
  }
  .screen3 .list-info-phone{
    padding-right: 55px;
  }
  .screen2 .only-list:hover>div,.screen3 .only-list:hover>div{
    -webkit-box-shadow:0px 0px 8px 2px rgba(0, 0, 0, 0.14);
    -moz-box-shadow:0px 0px 8px 2px rgba(0, 0, 0, 0.14);
    box-shadow:0px 0px 8px 2px rgba(0, 0, 0, 0.14);
  }
  .screen2 .list .swiper-slide>div,.screen3 .list .swiper-slide>div{
    padding-top: 8px;
  }
  .screen2 .btn a{
    font-size: 15px;
    width: 75px;
    height: 28px;
    line-height: 28px;
  }
  .screen3 .only-list>div{
    border-radius: 3px;
    padding:5px 5px 10px;
    line-height: 1.2;
  }
  .screen3 .loading-div, .screen3 .loading img{
    border-radius: 3px;
  }
  .screen3 .name{
    margin: 7px 0 5px;
  }
  .screen3 h3{
    font-size: 13px;
    font-weight: bold;
    color: #333333;
    line-height: 1.2;
  }
  .screen3 p{
    font-size: 12px;
  }
  .screen3 .list-info1{
    margin-bottom: 5px;
  }
  .screen3 .list-info{
    padding-left: 17px;
    height: 12px;
  }
  .screen3 .icon-address{
    width: 15px;
    height: 15px;
    margin-bottom: 5px;
    background-position: -56px -209px;
    top: 2px;
  }
  .screen3 .icon-phone{
    width: 15px;
    height: 15px;
    margin-bottom: 5px;
    background-position: -80px -207px;
    top: 1px;
  }
  .screen3 .btn a{
    width: 50px;
    height: 15px;
    border-radius: 2px;
    font-size: 9px;
    line-height: 15px;
  }
  .screen3 .only-list:hover .icon-qr{
    background-position: -340px -254px;
  }
  .screen3 .only-list:hover .icon-address{
    background-position: -56px -209px;
  }
  .screen3 .only-list:hover .icon-phone {
    background-position: -80px -207px;
  }
  @media (max-width:370px){
    .screen3 .only-list>div{
      padding-bottom: 28px;
    }
    .screen3 .list-info-phone{
      padding-right: 0;
    }
    .screen3 .btn {
      right: auto;
      left: 0;
      bottom: -27px;
    }
    .screen3 .phone-city .only-list>div{
      padding-bottom: 5px;
    }
    .screen3 .phone-city .btn {
      right: 0;
      left: auto;
      bottom: -5px
    }
  }

  .no-list-data .icon-qr,
  .only-list.no-list-data:hover .icon-href{
    display: none;
  }
  .no-list-data .name h3{
    color: #c7c7c7;
  }
  .no-list-data .btn a{
    opacity: 0.5;
    cursor: no-drop;
  }
</style>



// WEBPACK FOOTER //
// src/components/onlyList.vue